import clsx from 'clsx'
import { useRouter } from 'next/router'
import { useState, type FunctionComponent } from 'react'
import { selectFlavors } from '../../const/FlavorHelper'
import { InternalLink } from '../../const/Links'
import { BANNER_INDEX } from '../../const/digitContants'
import { useTranslate } from '../../contexts/TranslationContext'
import type { BrandResult } from '../../data/BrandFragment'
import { useActiveDog } from '../../user/ActiveDogContext'
import { useAuth } from '../../user/UserContext'
import { RegisterBanner } from '../static/RegisterBanner'
import { BrandBanner } from './BrandBanner'
import style from './Listing.module.sass'
import { ShowMoreButton } from './ShowMoreButton'
import { SuggestionModal } from './SuggestionModal'
import { TagRow } from './TagRow'

type ListingBrandsProps = {
	brands: BrandResult[]
	onNextPage: () => void
	hasNextPage: boolean
	totalCount: number
}

export const ListingBrands: FunctionComponent<ListingBrandsProps> = ({
	brands,
	onNextPage,
	hasNextPage,
	totalCount = false,
}) => {
	const { query } = useRouter()
	const [isSuggestionModalOpen, setIsSuggestionModalOpen] = useState(false)
	const auth = useAuth()
	const dog = useActiveDog()
	const isSignedUser = (auth.status === 'signedIn' && auth.user.verifiedAt) || auth.status === 'loading'

	const translate = useTranslate()
	const toggleSuggestionModal = (value: boolean) => {
		setIsSuggestionModalOpen(value)
	}

	return (
		<>
			<div className={style.bannerGroup}>
				{brands.map((brand, index) => (
					<div
						className={clsx(
							style.cardWrapper,
							(!dog || !isSignedUser) &&
								index === BANNER_INDEX &&
								brands.length !== BANNER_INDEX + 1 &&
								style.cardWrapperWithBanner,
						)}
						key={brand.id}
					>
						{brand && (
							<BrandBanner
								title={brand.name}
								key={brand.id}
								brandId={brand.id}
								buttonLabel={`${translate('listingBrands.title.multiple')} (${
									brand.paginateProducts.pageInfo.totalCount
								})`}
								lead={brand.lead}
								buttonDisabled={brand.paginateProducts.pageInfo.totalCount === 0}
								href={{
									pathname: `${InternalLink.Brand}${brand.slug}`,
									query: { ...query },
								}}
								imageUrl={brand.logo?.url}
								tagContent={selectFlavors(brand).length > 0 ? <TagRow tags={selectFlavors(brand)} /> : undefined}
							/>
						)}
						{!isSignedUser && index === BANNER_INDEX && brands.length !== BANNER_INDEX + 1 && <RegisterBanner />}
					</div>
				))}
			</div>
			{hasNextPage && (
				<div className={style.buttonWrapper}>
					<ShowMoreButton handleClick={onNextPage} itemsAmount={Number(totalCount) - brands.length} />
				</div>
			)}
			<SuggestionModal isModalOpen={isSuggestionModalOpen} handleClose={() => toggleSuggestionModal(false)} />
		</>
	)
}
